import QuickAddModal from './containers/QuickAddModalContainer'

export default QuickAddModal
